/**
 * LazyLoadBackground
 *
 * @since 1.0.0
 */
export default () => {
  const elements = document.querySelectorAll('.js-hero')

  if (elements.length < 1) {
    document.body.classList.add('no-hero')
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/Hero.js